type Testimonial = {
  init: () => void;
};

const Testimonial: Testimonial = {
  init() {
    const testimonialWidgets = document.querySelectorAll('[data-hook=testimonial]');

    if (testimonialWidgets.length === 0) return;

    // Swiper is only needed on pages that actually render a testimonial carousel, so load it
    // via a dynamic import() (its own async chunk) rather than bundling it into app.js for
    // every page.
    Promise.all([import('swiper'), import('swiper/modules')])
      .then(([{ default: Swiper }, { A11y, EffectFade, Keyboard, Navigation }]) => {
      testimonialWidgets.forEach((testimonialWidget) => {
      const swiperContainer: HTMLElement | null = testimonialWidget.querySelector('.swiper');

      if (swiperContainer) {
        const slides: HTMLElement[] = Array.from(testimonialWidget.querySelectorAll('.swiper-slide'));

        const nextButton = testimonialWidget?.querySelector('.swiper-button-next') as HTMLElement;
        const prevButton = testimonialWidget?.querySelector('.swiper-button-prev') as HTMLElement;

        if (slides.length < 2) return;

        // skipcq: JS-R1002
        new Swiper(swiperContainer, {
          modules: [A11y, EffectFade, Keyboard, Navigation],
          slidesPerView: 1,
          slidesPerGroup: 1,
          loop: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
            nextEl: nextButton, // '.swiper-button-next',
            prevEl: prevButton, // '.swiper-button-prev',
          },
          a11y: {
            enabled: true,
            slideRole: 'listitem',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'You are viewing the first slide',
            lastSlideMessage: 'This is the final slide',
            paginationBulletMessage: 'Navigate to slide {{index}}',
            containerMessage: 'Testimonial carousel',
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          on: {
            slideChange: (e) => {
              const liveRegion = swiperContainer.querySelector('.swiper-notification');
              const currentSlide = e.activeIndex + 1;
              if (liveRegion) {
                liveRegion.textContent = `Navigated to slide ${currentSlide}`;
              }
            },
          },
        });
      }
      });
    })
      .catch((error) => {
        console.error('Failed to load Swiper for testimonial carousel:', error);
      });
  },
};

export default Testimonial;
